import axios from '../axios';
import { TRIALS_NEST_API_ROOT } from '../constants';
import { NextSearchTriggerBody, NextSearchTriggerResponseDto } from '../types/nextSearch';

export const nextSearchApi = {
  /**
   * Enqueue a scoped manual next-search run. Returns 202 with a runId when the job is accepted.
   * Auth, DTO, and missing/inactive pathway failures are HTTP errors; patient/run validation
   * happens asynchronously in the worker.
   */
  trigger: async (body: NextSearchTriggerBody): Promise<NextSearchTriggerResponseDto> => {
    const { data } = await axios.post<NextSearchTriggerResponseDto>(
      `${TRIALS_NEST_API_ROOT}/next-search/trigger`,
      body,
    );
    return data;
  },
};
